import axios from 'axios'

const apiClient = axios.create({
    baseURL: process.env.REACT_APP_API_URL + '/india-express/api/v1',
    headers: {
        'Content-Type': 'application/json'
    },
    withCredentials: true,
})

export default apiClient;